/**
 * Tab navigation atoms
 *
 * Pure Jotai atoms for tab state management.
 */

import { atom } from "jotai";
import type { Tab, DesignSubTab } from "@design-lab/shared/types/tab";

/**
 * Tracks which tabs have been visited by the user
 */
export const visitedTabsAtom = atom<Set<Tab>>(new Set<Tab>());

/**
 * Active sub-tab within the Design tab (for A/B test variant)
 */
export const designSubTabAtom = atom<DesignSubTab>("front");

/**
 * Whether design sub-tab has been initialized
 */
export const designSubTabInitializedAtom = atom<boolean>(false);

/**
 * Whether the tab info panel is expanded
 */
export const tabInfoExpandedAtom = atom<boolean | undefined>(undefined);
